<template>
  <span class="badge mr-2" :class="paymentobj.classe">{{ paymentobj.label }}</span>       
</template>

<script>
import { statusPaiement } from '@/modules/order/plugins/status';

export default {
  name: 'MessageError',
  props:{
      payment: Number
  },
  computed:{
    paymentobj(){
      if(statusPaiement){
        return statusPaiement.find(status => status.value === parseInt(this.payment))
      }else{
        return 'N/A'
      }
      
    }
  },
  data(){
      return {
        statusPaiement: statusPaiement,
      }
  },
  methods: {
    
  },
}
</script>

<style>
</style>
  